import { createReducer, on } from "@ngrx/store";

import { initialConditionState } from "@app/project/store/clarehome.state";
import { LoadingState } from "@app/root-store/api-result.state";
import { ConditionActions } from "../actions";
import { CHConditionState } from "../rule.state";

export const conditionReducer = createReducer(
    initialConditionState(),
    on(
        ConditionActions.loadSet.request,
        (state, { uuid }): CHConditionState => ({
            ...state,
            uuid,
            callState: LoadingState.loading,
        })
    ),
    on(
        ConditionActions.loadSet.success,
        (state, { uuid, conditions }): CHConditionState => ({
            ...state,
            uuid,
            result: conditions,
            callState: LoadingState.loaded,
        })
    ),
    on(ConditionActions.clearConditionState, (): CHConditionState => initialConditionState())
);
